import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'basicBlock',
  props: {
    icon: {
      type: String
    },
    background: {
      type: String
    },
    to: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    text: {
      type: String
    },
    dept: {
      type: String
    },
    time: {
      type: [Number, String]
    },
    gutter: {
      type: [Number, String],
      default: 5
    },
    color: {
      type: String
    },
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    }
  },
  computed: {
    styleName: function styleName() {
      return {
        animationDelay: "".concat(this.time / 25, "s"),
        width: this.setPx(this.width),
        height: this.setPx(this.height),
        margin: this.setPx(this.gutter)
      };
    },
    boxStyleName: function boxStyleName() {
      return {
        backgroundColor: this.color,
        backgroundImage: "url('".concat(this.background, "')")
      };
    }
  }
};